import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(url: any) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({ name: 'formatAiTheme' })
export class FormatAiThemePipe implements PipeTransform {
  constructor() {}
  transform(str: any) {
    return str.replaceAll('_', ' ');
  }
}

@Pipe({ name: 'translateEmotion' })
export class TranslateEmotionPipe implements PipeTransform {

  mapping: any = {
    gioia: 'Joy',
    fiducia: 'Trust',
    paura: 'Fear',
    sorpresa: 'Surprise',
    tristezza: 'Sadness',
    disgusto: 'Disgust',
    rabbia: 'Anger',
    aspettativa: 'Expectation',
    indefinibile: 'Undefinable',
    non_risposta: 'No-answer',
  };

  constructor() {}
  transform(str: any) {
    const key = str.toLowerCase().replaceAll(' ', '_');

    return this.mapping[key] ? this.mapping[key] : str;
  }
}

@Pipe({ name: 'translateTone' })
export class TranslateTonePipe implements PipeTransform {

  mapping: any = {
    positivo: 'Monitor',
    negativo: 'Act',
    neutro: 'Review',
    misto: "Review",
  };

  constructor() {}
  transform(str: any) {
    const key = str.toLowerCase();

    return this.mapping[key] ? this.mapping[key] : str;
  }
}
